import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito saber cocinar?',
    a: 'No. La receta más compleja tiene 6 pasos. La más simple, 3 ingredientes.'
  }, {
    q: '¿Es solo para bajar de peso?',
    a: 'No. El objetivo es controlar la ansiedad y mejorar tu relación con la comida.'
  }, {
    q: '¿Puedo acceder desde el celular?',
    a: 'Sí. PDF compatible con todos los dispositivos. Sin internet luego de descargarlo.'
  }, {
    q: '¿Cuándo recibo el acceso?',
    a: 'Inmediatamente. Menos de 2 minutos después del pago.'
  }, {
    q: '¿La garantía es real?',
    a: '100%. Un mail es suficiente para el reembolso completo.'
  }, {
    q: '¿Por qué $19.990?',
    a: 'Una consulta con nutricionista cuesta entre $8.000 y $15.000. Esto reemplaza meses de consultas por el resto de tu vida.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-chocolate-50 py-20 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-chocolate-900 mb-12" data-id="element-37">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-chocolate-800/10 overflow-hidden transition-all duration-200" data-id="element-39">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-40">
                <span className="font-bold text-lg text-chocolate-900 pr-4" data-id="element-41">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-gold-500 flex-shrink-0" data-id="element-42" /> : <ChevronDown className="w-5 h-5 text-chocolate-800/40 flex-shrink-0" data-id="element-43" />}
              </button>

              {openIdx === idx && <div className="px-6 pb-5 text-chocolate-800" data-id="element-44">
                  <p data-id="element-45">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}